// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './elements'
import './controllers'
import 'form-request-submit-polyfill'
import { handleTurboStreamRender, handleLoadAction } from './util/turbo-stream'
import { setConfig } from './util/config'
import { StreamActions } from '@hotwired/turbo'

import LocalTime from 'local-time'

LocalTime.start()

document.addEventListener('turbo:before-stream-render', handleTurboStreamRender)

document.addEventListener('turbo:morph', (event) => {
  console.log('turbo:morph', event)
})

// reload local-time instances after a page morph
document.addEventListener('turbo:morph', () => LocalTime.run())

StreamActions.load = () => handleLoadAction(this)

// data pipeline of events captured before we finished loading this script
// catch up the events in the list, then set up future events to call directly

window.bscoData = window.bscoData || []

function executePageCommand () {
  const args = Array.prototype.slice.call(arguments)
  const context = args.shift()

  if (context === 'set') {
    setConfig.apply(undefined, args)
  }
}

const catchUp = window.bscoData

window.bscoData = {
  push: (args) => executePageCommand.apply(undefined, args)
}

Array.from(catchUp).forEach((args) => executePageCommand.apply(undefined, args))
